import React from "react";

export default function BrandArrowDown(props: { text: "light" | "dark" }) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="11" viewBox="0 0 10 11" fill="none">
      <g clipPath="url(#3o5bqlvxpa)">
        <path
          d="M.625 3.1 5 8l4.375-4.9"
          stroke={props.text === "light" ? "transparent" : "#000"}
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="3o5bqlvxpa">
          <path fill="#fff" transform="translate(0 .5)" d="M0 0h10v10H0z" />
        </clipPath>
      </defs>
    </svg>
  );
}
